 
// Helper functions
export const getCountries = () => menaCountries

export const getStates = (countryCode) => {
  return menaStates[countryCode] || []
}

export const getCities = (countryCode) => {
  return menaCities[countryCode] || []
}

export const getCountryName = (countryCode) => {
  const country = menaCountries.find(c => c.isoCode === countryCode)
  return country ? country.name : ''
}

export const getStateName = (countryCode, stateCode) => {
  const states = getStates(countryCode)
  const state = states.find(s => s.isoCode === stateCode)
  return state ? state.name : ''
}

export const getCityName = (countryCode, cityId) => {
  const cities = getCities(countryCode)
  const city = cities.find(c => c.id === cityId)
  return city ? city.name : ''
}

// New function to fetch cities from API
export const fetchCitiesFromAPI = async (countryCode) => {
  try {
    const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'
    const token = localStorage.getItem('access_token')
    
    if (!countryCode) {
      console.warn('No country code provided for cities API call')
      return []
    }
    
    if (!token) {
      console.warn('No authentication token found for cities API call')
      return []
    }

    const response = await fetch(`${API_BASE_URL}/api/v1/locations/cities/country-code/${countryCode}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })

    if (!response.ok) {
      console.warn(`Failed to fetch cities for country ${countryCode}:`, response.status, response.statusText)
      // Fallback to local data if API fails
      return getCities(countryCode)
    }

    const result = await response.json()
    
    // Handle different response structures
    let cities = []
    if (result.data && Array.isArray(result.data)) {
      cities = result.data
    } else if (Array.isArray(result)) {
      cities = result
    } else if (result.cities && Array.isArray(result.cities)) {
      cities = result.cities
    } else if (result.results && Array.isArray(result.results)) {
      cities = result.results
    }


    // Transform API response to match expected format
    const transformedCities = cities.map((city, index) => ({
      id: city.id || city.city_id || city.cityId || index + 1,
      name: city.name || city.name_en || city.nameEn || city.city_name || city.cityName || 'Unknown City'
    }))

    
    // If API returns no cities, fallback to local data
    if (transformedCities.length === 0) {
      return getCities(countryCode)
    }
    
    return transformedCities

  } catch (error) {
    console.error('Error fetching cities from API:', error)
    // Fallback to local data if API fails
    return getCities(countryCode)
  }
}
